import { InputActionType } from "./InputActionType"
import type { InputActionTypeMeta } from "./InputActionTypeMeta.type"

const inputActionTypeMetaList: Array<InputActionTypeMeta> = [
  c(InputActionType.Escape, 'Escape'),
  c(InputActionType.Delete, 'Delete'),
  c(InputActionType.Duplicate, 'Duplicate'),
  c(InputActionType.RotateClockwise, 'Rotate Clockwise'),
  c(InputActionType.RotateCounterClockwise, 'Rotate Counter-Clockwise'),
  c(InputActionType.EndTurn, 'End Turn'),
  c(InputActionType.StartTurn, 'Start Turn'),
  c(InputActionType.Primary, 'Primary Action'),
  c(InputActionType.Secondary, 'Secondary Action'),
  c(InputActionType.ActionLogMenu, 'Toggle Action Log Menu'),
  c(InputActionType.CenterToPosition, 'Center to Position'),
  c(InputActionType.SelectInspectTool, 'Inspect'),
  c(InputActionType.SelectPrevUnit, 'Select Previous Unit'),
  c(InputActionType.SelectNextUnit, 'Select Next Unit'),
  c(InputActionType.CameraDefaultPolarAngle, 'Reset Camera Angle'),
  c(InputActionType.CameraTopDownPolarAngle, 'Top-Down Camera View'),
  c(InputActionType.CameraIncreaseFov, 'Increase Field of View'),
  c(InputActionType.CameraDecreaseFov, 'Decrease Field of View'),
  c(InputActionType.CameraIncreaseFar, 'Increase Camera Far'),
  c(InputActionType.CameraDecreaseFar, 'Decrease Camera Far'),
  c(InputActionType.CameraIncreasePixelation, 'Increase Pixelation'),
  c(InputActionType.CameraDecreasePixelation, 'Decrease Pixelation'),
  c(InputActionType.CameraIncreaseZoom, 'Zoom In'),
  c(InputActionType.CameraDecreaseZoom, 'Zoom Out'),
  c(InputActionType.CameraRotateClockwise, 'Rotate Camera Clockwise'),
  c(InputActionType.CameraRotateCounterClockwise, 'Rotate Camera Counter-Clockwise'),
  c(InputActionType.RotateNextHome, 'Rotate to Next Home'),
  c(InputActionType.UnitWait, 'Unit Wait'),
  c(InputActionType.CommitMove, 'Commit Move'),
  c(InputActionType.UnitPickup, 'Unit Pickup'),
  c(InputActionType.PlayersList, 'Show Players List'),
  c(InputActionType.UnitLoad, 'Unit Load'),
  c(InputActionType.UnitUnload, 'Unit Unload'),
  c(InputActionType.UnitAnnex, 'Unit Annex'),
  c(InputActionType.UnitBombard, 'Unit Bombard'),
  c(InputActionType.UnitMerge, 'Unit Merge')
]

function c(id: InputActionType, dname: string): InputActionTypeMeta {
  return { id, dname }
}

export default inputActionTypeMetaList
